
export const environment = {
    production: true,
      v: '1',
      serverUrl: "https://mbc.qualitapp.com/",
      logoUrl: 'assets/logo_brio.png',
      appName: 'calidad'
  };